import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { formatNumber, DateFormatter } from '../../utils/date';
import {Link} from 'react-router';
import Helmet from 'react-helmet';
import Pixeltext from '../../components/svg/pixeltext';
import forEach from 'lodash/forEach';
import { profilesRoute, editorialRoute } from '../../routes/index';
import formatCredits from '../../utils/formatCredits';

// Components Import
import Carousel from '../../components/carousel/carousel';
import ThreeImages from '../../components/threeimages/threeimages';
import Comments from '../../components/comments/comments';
import Evolution from '../../components/evolution/evolution';
import RelatedInterviews from '../../components/relatedinterviews/relatedinterviews';
import RelatedCases from '../../components/relatedcases/relatedcases';
import RelatedJobs from '../../components/relatedjobs/relatedjobs';
import ContextualMenu from '../../components/contextual/contextual';

import Share from '../../components/share/share';
import { Player, PlayerTrigger } from '../../components/video/player';

import Countdown from '../../components/countdown/countdown';

// Extra
import getCategoryName from '../../utils/getCategoryName';
import Image from '../../components/image/image';
import SweetScroll from 'sweet-scroll';
import metaDesc from '../../utils/meta';

import css from './case.scss';

import connect from '../../utils/connect';

import { fetchSingleCase, clearAction } from '../../actions/cases';

class Case extends Component {
	static propTypes = {
		browser: PropTypes.object.isRequired,
	};

	constructor(props) {
		super();

		this.state = {
			timeLeft: 0,
			loading: true,
			showVideo: false,
			autoplay: true,
		};

		this.timeInterval = false;
		this.metaDesc = '';
		this.didScroll = false;
		this.shouldAutoplay = this.shouldAutoplay.bind(this);
	}

	componentWillUnmount() {
		clearInterval(this.timeInterval);
		this.clearCases();
		this.props.browser.scroll.deregister(this.shouldAutoplay);
	}

	componentWillMount() {
		this.fetchSingle = bindActionCreators(fetchSingleCase, this.props.dispatch);
		this.clearCases = bindActionCreators(clearAction, this.props.dispatch);

		let preview = false;
		if (this.props.router.location && this.props.router.location.query && this.props.router.location.query.preview) {
			preview = this.props.router.location.query.preview
		}

		if (
			this.props.routeParams.slug &&
			this.props.routeParams.slug !== this.props.cases.single.slug
		) {
			this.fetchSingle(this.props.routeParams.slug, preview);
			if (!this.state.loading) {
				this.setState({
					loading: true,
				});
			}
		}

		this.props.browser.scroll.register(this.shouldAutoplay);
	}

	shouldAutoplay(ev) {
		if (ev.scrollY > 850 && this.state.autoplay) {
			this.setState({
				autoplay: false,
			});
		} else if (ev.scrollY < 850 && this.state.autoplay === false) {
			this.setState({
				autoplay: true,
			});
		}
	}

	componentWillReceiveProps(nextProps, nextState) {
		let preview = false;
		let newState = {};
		if (nextProps.router.location && nextProps.router.location.query && nextProps.router.location.query.preview) {
			preview = nextProps.router.location.query.preview
		}

		if (
			this.props.routeParams.slug !== nextProps.routeParams.slug
		) {
			this.fetchSingle(nextProps.routeParams.slug, preview);
			if (!this.state.loading) {
				newState.loading = true;
			}
		}

		if (
			nextState.loading &&
			nextProps.routeParams.slug === nextProps.cases.single.slug &&
			(
				!nextProps.cases.single.slide1 ||
				!nextProps.cases.single.slide2 ||
				!nextProps.cases.single.slide3
			)
		) {
			newState.loading = false;
		}

		(Object.keys(newState).length) && this.setState(newState);
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextState.showVideo !== this.state.showVideo ||
			nextProps.browser.window.width !== this.props.browser.window.width ||
			nextProps.cases.single.id !== this.props.cases.single.id ||
			this.props.users._id !== nextProps.users._id ||
			nextState !== this.state
		);

		// update on init
		// if ((!this.props.items.length && nextProps.items.length)) {
		// 	return true;
		// }
	}

	componentWillUpdate(nextProps, nextState) {
		// if (
		// 	this.state.loading === true &&
		// 	nextProps.cases.single.id !== this.props.cases.single.id
		// ) {
		// 	this.setState({
		// 		loading: false,
		// 	});
		// }
	}

	componentDidUpdate() {
		if(window.location.hash && window.location.hash == '#case-extras' && !this.didScroll) {
			const scroller = new SweetScroll({ easing: 'easeOutQuint', offset: -100, duration: 700 });
			scroller.to('#case-extras');
			this.didScroll = true;
			// console.log('Hall');
		}
	}

	// componentWillReceiveProps(nextProps) {
	// 	if (nextProps.routeParams.slug !== this.props.routeParams.slug) {
	// 		//this.fetchSingle(nextProps.routeParams.slug);
	// 	}
	// }

	render() {
		let item = this.props.cases.single;
		let awardTitle = '';

		let createdDate = new DateFormatter(item.sortedDate);

		let winDate = new DateFormatter();
		let awardDate = 0;

		let awardDates = [];
		let awards = [];

		let hasFOTD = false;
		let hasMOTD = false;
		let fotdText = '';
		let fotdDate = '';

		let transitionClass = 'page__transition';

		if (this.state.loading) {
			transitionClass += ' page__transition--transitioning';
		}

		let otherAwards = [];

		forEach(item.awards, function(award, i) {
			awardDates[i] = award.awardedDate;
			awards[award.awardedDate] = award.name;

			if (award.type == 'FOTD') {
				hasFOTD = true;
				fotdText = award.name;
				fotdDate = award.awardedDate;
			} else {

				if (award.type == 'MOTD' && !hasFOTD) {
					hasMOTD = true;
					fotdText = award.name;
					fotdDate = award.awardedDate;
				} else {
					otherAwards.push(award);
				}
			}
		});

		if (!hasFOTD && !hasMOTD) {
			fotdText = 'submitted project -';
			fotdDate = item.timestamp * 1000;
		}

		let isVoting = false;

		let evolutionShow = false;
		let pointsShow = false;

		awardDates.sort();

		awardTitle = awards[awardDates[awardDates.length - 1]];
		awardDate = awardDates[awardDates.length - 1];

		let useDate = new DateFormatter(fotdDate);

		if (!item.awards && item.days < 15) {
			isVoting = true;
		}

		if (item.evolution && item.evolution.length && hasFOTD || item.evolution && item.evolution.length && isVoting) {
			evolutionShow = true;
		}

		if (!item.legacy && hasFOTD || !item.legacy && isVoting) {
			pointsShow = true;
		}

		let leftString = '';

		let imgSpan = { desktop: 'span9', tablet: 'span14', mobile: 'span12' };
		let slides = [];

		//pointsShow = true;
		for (let i = 1; i <= 3; i++) {
			let currentImage = item[`slide${i}`];
			currentImage && slides.push(
				<Image key={`slide${i}`} img={currentImage} span={imgSpan} alt='' browser={this.props.browser} onLoad={() => this.onImageLoaded()} />
			);
		}

		(!!item.showreelUrl) && slides.push(
			<PlayerTrigger key='slideVideo' url={item.showreelUrl} codaClass='slide-coda__item--is-video' skipSlide onClick={(e) => {
				this.setState({
					...this.state,
					showVideo: !this.state.showVideo,
				});
			}} />
		);

		if (item.meta && item.meta.description !== this.metaDesc) {
			metaDesc(item.meta.description);
			this.metaDesc = item.meta.description;
		}

		return (
			<div>
				{item.title && (
					<article className='case-single span14 margin-bottom-contextual'>
						<Helmet title={`${item.title} - The FWA`} />

						<div className={transitionClass}>
							{item.secondsLeftFotd && (
								<div className='case-single__time-left span14'>
									<div className='case-single__time-left__left span5 span4-tablet span14-mobile'>
										<span className='case-single__time-left__left__title'>Time left in front of the jury:</span>
									</div>
									<Countdown timeLeft={item.secondsLeftFotd} spans={'span9 span10-tablet span14-mobile'} />
									<div className='case-single__spacer span7-mobile pixel-pattern span5 hide-tablet hide-mobile'></div>
									<div className='case-single__spacer case-single__spacer--white span7-mobile span5 hide-tablet hide-desktop'></div>
								</div>
							)}

							{!!(otherAwards.length) && (
								<div className='case-single__extra-awards span14'>
									<div className='case-single__extra-awards__left span5 span4-tablet span2-mobile'></div>
									<Carousel autoplay={true} timer={6000} sliderClass='case-single__extra-awards__slider span9 span10-tablet span12-mobile' decoClass='case-single__extra-awards__deco'>
										{otherAwards.map((award, i) => this.renderAward(award, i))}
									</Carousel>
									<div className='case-single__spacer span7-mobile pixel-pattern span5 hide-tablet hide-mobile'></div>
								</div>
							)}
							<div className='case-single__details span5 span14-tablet span14-mobile'>
								<div className='case-single__details__top'>
									<div className='case-single__details__top__share'>
										<Share handle={this.shareHandle} title={item.title} url={window.location.href} browser={this.props.browser}/>
									</div>
									<div className='case-single__details__top__date span2 span4-tablet span4-tablet-plus span14-mobile pixel-pattern'>
										<Pixeltext text={useDate.date} className='case-single__details__day' />
										<span className='case-single__details__month'>{useDate.month} {useDate.year !== (new Date().getYear()) ? useDate.year : ''}</span>
										<span className='case-single__details__award'>{fotdText}</span>
									</div>
								</div>
								<div className='case-single__details__bottom hide-tablet hide-mobile'>
									<div className='case-single__details__content'>
										{item.title && (
										<span className='case-single__details__type'>{getCategoryName(item.caseTypes.name, item.bestViewedOn)}</span>
										)}
										<h1 className='case-single__details__title'>{item.title}</h1>
									</div>
								</div>
							</div>
							<div className='span14-tablet span12-mobile case-single__slider-holder span9 pixel-pattern pixel-pattern--dark'>
								<Carousel autoplay={this.state.autoplay}>
									{slides}
								</Carousel>
								{hasFOTD && (
									<div className='ribbon-fotd ribbon-fotd--br'></div>
								)}

								{(!!item.showreelUrl) && (
									<Player url={item.showreelUrl} showVideo={this.state.showVideo} onClose={() => { this.setState({ ...this.state, showVideo: false }); }} browser={this.props.browser} />
								)}
							</div>
							<div className={'span2 hide-desktop hide-tablet case-single__slider-dots' + (pointsShow ? ' case-single__slider-dots--wpoints' : '')}></div>

							{pointsShow && (
								<div className='case-single__meta-scorecard span5 span8-tablet pixel-pattern span12-mobile hide-tablet hide-desktop'>
									<div className='case-single__meta-scorecard__stats hide-mobile'>
										<h3 className='case-single__meta-scorecard__title'>FWA award stats:</h3>
									</div>
									<div className='case-single__meta-scorecard__points' ref='pointsTooltipTablet'>
										<h3 className='case-single__meta-scorecard__title'>Points:</h3>
										{item.points && (
											<span className='case-single__meta-scorecard__number'>{formatNumber(item.points)}</span>
										)}
									</div>
									<div className='case-single__meta-scorecard__days'>
										<h3 className='case-single__meta-scorecard__title'>Days:</h3>
										<span className='case-single__meta-scorecard__number'>{item.days}</span>
									</div>
								</div>
							)}

							<div className='case-single__details--small span8 hide-desktop span14-mobile'>
								<div className='case-single__details--small__content'>
									{item.title && (
									<span className='case-single__details__type'>{getCategoryName(item.caseTypes.name, item.bestViewedOn)}</span>
									)}
									<h1 className='case-single__details__title span5 span100p-mobile'>{item.title}</h1>
								</div>
							</div>

							{pointsShow && (
								<div className='case-single__meta-scorecard span5 span8-tablet pixel-pattern hide-mobile'>
									<div className='case-single__meta-scorecard__stats hide-mobile'>
										<h3 className='case-single__meta-scorecard__title'>FWA award stats:</h3>
									</div>
									<div className='case-single__meta-scorecard__points' ref='pointsTooltipTablet'>
										<h3 className='case-single__meta-scorecard__title'>Points:</h3>
										{item.points && (
											<span className='case-single__meta-scorecard__number'>{formatNumber(item.points)}</span>
										)}
									</div>
									<div className='case-single__meta-scorecard__days'>
										<h3 className='case-single__meta-scorecard__title'>Days:</h3>
										<span className='case-single__meta-scorecard__number'>{item.days}</span>
									</div>
								</div>
							)}

							<section className='span14 case-single__description'>
								<div className='case-single__description__buttons span14-mobile'>
									{item.comments && (
										<a href='#comments' onClick={(event) => this.sweetScroll(event)} className='case-single__description__button button'>Discuss the project ({item.comments.length})</a>
									)}
									{item.url && (
										<a href={item.url} target='_blank' className='case-single__description__button button--go button--dark button'>Launch Project</a>
									) || (
										<span className='case-single__description__button button--dark button'>Project offline</span>
									)}
								</div>
								<div className='case-single__description__content span10 span14-mobile'>
									<h2 className='case-single__description__title'>description:</h2>
									<p className='case-single__description__text'>{item.description}</p>
								</div>
							</section>

							{(item.extraText || item.extraTitle) && (
								<section className='span14 case-single__extra' id='case-extras'>
									<div className='span5 span14-tablet span14-mobile'>
										<h2 className='case-single__extra__title span3 span5-tablet span11-mobile'>{item.extraTitle}</h2>
									</div>
									<div className='span9 span14-tablet span14-mobile'>
										<p className='span8 span13-tablet span13-mobile case-single__extra__text'>{item.extraText}</p>
									</div>
								</section>
							)}

							{!item.legacy && (
								<section className='span9 case-single__credits span14-mobile'>
									<h2 className='case-single__credits__title'>Credits:</h2>
									<p className='case-single__credits__profiles'>{formatCredits(item.profiles)}</p>
								</section>
							) || (
								<section className='span5 case-single__credits solo span14-mobile'>
									<h2 className='case-single__credits__title'>Credits:</h2>
									<p className='case-single__credits__profiles'>{formatCredits(item.profiles)}</p>
								</section>
							)}

							{((item.extra1 || item.extra1Video) && (item.extra2 || item.extra2Video) && (item.extra3 || item.extra3Video)) && (
								<ThreeImages
									imgone={item.extra1}
									imgtwo={item.extra2}
									imgthree={item.extra3}
									video1={item.extra1Video}
									video2={item.extra2Video}
									video3={item.extra3Video}
									browser={this.props.browser}
								/>
							)}

							{(item.extra1 && item.extra2 && item.extra3) && (
								<div className='case-single__spacer span7-mobile pixel-pattern span5'></div>
							)}

							<div className='cf'></div>

							{!!evolutionShow && (
								<Evolution evolution={item.evolution} awardDate={awardDate} fotdText={fotdText} hasFOTD={hasFOTD} points={item.points} days={item.days} browser={this.props.browser}/>
							)}

							{evolutionShow && (
								<div className='case-single__spacer span7-mobile pixel-pattern span5'></div>
							)}

							{!!(item.relatedInterviews && item.relatedInterviews.length) && (
								<RelatedInterviews interviews={item.relatedInterviews} browser={this.props.browser} title='Related Interviews' />
							)}

							{!!(item.relatedInterviews && item.relatedInterviews.length) && (
								<div className='case-single__spacer span7-mobile pixel-pattern span5'></div>
							)}

							{!!(item.relatedJobs && item.relatedJobs.length) && (
								<RelatedJobs jobs={item.relatedJobs} title='Related Jobs' browser={this.props.browser} />
							)}

							{!!(item.relatedJobs && item.relatedJobs.length) && (
								<div className='case-single__spacer span7-mobile pixel-pattern span5'></div>
							)}

							<div className='cf'></div>

							<Comments slug={item.slug} dispatch={this.props.dispatch} title={item.title} users={this.props.users} comments={item.comments} browser={this.props.browser} />

							{!!(item.relatedCases && item.relatedCases.length) && (
								<div className='case-single__spacer span7-mobile case-single__spacer span7-mobile--border pixel-pattern span5'></div>
							)}

							{!!(item.relatedCases && item.relatedCases.length) && (
								<RelatedCases
									id={item.id}
									typeSlug='cases'
									parentSlug={item.slug}
									cases={item.relatedCases}
									browser={this.props.browser}
									names={item.profiles.map((profile, i) => this.profileWithUrl(profile, i, item.profiles))}
									total={item.relatedCasesCount}
									/>
							)}

							<div className='cf'></div>
						</div>

						{!!(otherAwards.length || hasFOTD || hasMOTD) && (
							<ContextualMenu next={item.next} prev={item.prev} enableCases />
						)}
					</article>
				)}
			</div>
		);
	}

	onImageLoaded() {
		if (this.state.loading) {
			this.setState({
				loading: false,
			});
		}
	}

	renderAward(award, i) {
		let uid = 'extraAward' + i;
		let date = new DateFormatter(award.awardFor);

		return (
			<div key={uid} className='case-single__extra-awards__award span9 span10-tablet span12-mobile'>
				<div className={'ribbon-' + award.type.toLowerCase() + ' ribbon-' + award.type.toLowerCase() + '--tr'}></div>
				<span className='case-single__extra-awards__award__name'>{award.name + ' '}</span>
				{award.type == 'FOTM'  && (
					<span className='case-single__extra-awards__award__date'>{date.month + ' ' + date.year}</span>
				)}

				{award.type == 'TCEA' && (
					<span className='case-single__extra-awards__award__date'>{date.date + ' ' + date.monthShort + ' ' + date.year}</span>
				)}

				{award.type == 'FOTY' && (
					<span className='case-single__extra-awards__award__date'>{date.year}</span>
				)}

				{award.type == 'TCEAY' && (
					<span className='case-single__extra-awards__award__date'>{date.year}</span>
				)}
			</div>
		);
	}

	sweetScroll(e) {
		e.preventDefault();
		const scroller = new SweetScroll({ easing: 'easeOutQuint', offset: -60, duration: 700 });
		scroller.to('#comment');
	}

	hasClass(element, cls) {
		return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
	}

	renderInterview(interview, i) {
		let createdDate = new DateFormatter(interview.createdDate);
		let uid = interview.uid || ('interview' + interview.id);
		return (
			<li key={uid} className='related-interviews__interview'>
				<Image className='related-interviews__interview__image span5 hide-mobile' img={interview.image} span='span14' alt='' browser={this.props.browser} />
				<div className='related-interviews__interview__buttons-container span5 span14-mobile'>
					<Link to={editorialRoute(interview.slug)} className='related-interviews__interview__button button'>Read Interview <i className='arrow'></i></Link>
				</div>
				<div className='related-interviews__interview__date span2 pixel-pattern hide-tablet hide-mobile'>
					<Pixeltext text={createdDate.date} className='related-interviews__interview__day' y='15px' textAnchor='end'/>
					<span className='related-interviews__interview__month'>{createdDate.month}</span>
					<span className='related-interviews__interview__award'>Interview —</span>
				</div>
				<div className='related-interviews__interview__right span7 span9-tablet span14-mobile'>
					<h4 className='related-interviews__interview__byline'>By {interview.users.name}</h4>
					<h4 className='related-interviews__interview__small-date hide-desktop'>{createdDate.date + ' ' + createdDate.month + ', ' + createdDate.year}</h4>
					<div className='related-interviews__interview__content'>
						<h3 className='related-interviews__interview__title'>{interview.title}</h3>
						<p className='related-interviews__interview__text'>{interview.excerpt}</p>
					</div>
				</div>
			</li>
		);
	}

	formatProfiles(profiles = []) {
		let names = [];

		for (var i = 0; i < profiles.length; i++) {
			if (profiles[i].name) {
				names.push(profiles[i].name);
			}
		}

		return names.join(', ');
	}

	profileWithUrl(profile, i, profiles) {
		let uid = 'profile' + i;
		let url = profilesRoute(profile.slug);
		let split = '';

		if (profiles.length > 1) {
			split = ', ';
		}

		if (i == profiles.length - 1) {
			split = '';
		} else if (i == profiles.length - 2) {
			split = ' and ';
		}

		return (
			<span key={uid} className='related-cases__agencies'>
				<Link to={url}>{profile.name}</Link>
				{split}
			</span>
		);
	}
}

export default connect(Case);



/** WEBPACK FOOTER **
 ** ./frontend/containers/case/case.js
 **/